import {OFFER_3D_VIEWS} from "../constants/offer_3d_views";

const offer3dViewIds = OFFER_3D_VIEWS.map((view) => view.id);

export type Offer3dViewIdSource =
    | {
          id?: number;
          group_primary_offer?: {id?: number} | null;
      }
    | null
    | undefined;

export const resolveOffer3dViewId = (offer: Offer3dViewIdSource): number | undefined => {
    //bcs of offer stages we need to check primary id first
    const primaryId = offer?.group_primary_offer?.id;
    if (primaryId != null) {
        return primaryId;
    }
    return offer?.id;
};

export const hasOffer3dView = (offer: Offer3dViewIdSource): boolean => {
    const id = resolveOffer3dViewId(offer);
    return id != null && offer3dViewIds.includes(id);
};

export const getOffer3dViewLink = (offerId: number, stageId?: number): string | undefined => {
    const entry = OFFER_3D_VIEWS.find((view) => view.id === offerId);
    if (!entry) {
        return undefined;
    }

    if (stageId && entry.stageLinks) {
        const stageLink = entry.stageLinks.find((sl) => sl.stageId === stageId);
        if (stageLink) {
            return stageLink.link ?? entry.link;
        }
    }

    return entry.link;
};
import {OFFER_3D_VIEWS} from "../constants/offer_3d_views";

const offer3dViewIds = OFFER_3D_VIEWS.map((view) => view.id);

export type Offer3dViewIdSource =
    | {
          id?: number;
          group_primary_offer?: {id?: number} | null;
      }
    | null
    | undefined;

export const resolveOffer3dViewId = (offer: Offer3dViewIdSource): number | undefined => {
    //bcs of offer stages we need to check primary id first
    const primaryId = offer?.group_primary_offer?.id;
    if (primaryId != null) {
        return primaryId;
    }
    return offer?.id;
};

export const hasOffer3dView = (offer: Offer3dViewIdSource): boolean => {
    const id = resolveOffer3dViewId(offer);
    return id != null && offer3dViewIds.includes(id);
};

export const getOffer3dViewLink = (offerId: number, stageId?: number): string | undefined => {
    const entry = OFFER_3D_VIEWS.find((view) => view.id === offerId);
    if (!entry) {
        return undefined;
    }

    if (stageId && entry.stageLinks) {
        const stageLink = entry.stageLinks.find((sl) => sl.stageId === stageId);
        if (stageLink) {
            return stageLink.link ?? entry.link;
        }
    }

    return entry.link;
};
